import { useContext } from 'react';
import AccountContext from './accountContext';

const useAccountContext = () => useContext(AccountContext);

export default useAccountContext;
